import { addOffCanvasPanelListeners } from '../off-canvas-panel/off-canvas-panel';
import { gaTracking, dispatchEventWrapper } from '../event/event';
import { isMobile } from '../mobile-detect/mobile-detect';
import { scrollTo, getOffset, scrollToOnContainer } from '../utility-functions/utility-functions';
import { clearSavedScrollPosition, saveOpenFilter, clearOpenFilter } from '../page-loader/utility-functions';

const DEFAULTS = {
    toggleFilters: '.js-toggle-filters',
    openFilters: '.js-open-filters',
    filtersContainer: '.filters-container',
    filterGroup: '.filter-group',
    filterHeadings: '.filter-group__heading',
    filterBody: '.filter-group__body',
    filterCloseButtons: '.js-close-filters',
    filterClearGroupButtons: '.js-clear-filter-group',
    toggleSortBy: '.js-toggle-sort-by',
    sortByContainer: '.filter-group__sortby',
    filterDraw: '.filters-draw',
    navLink: '.filters-draw .nav-link',
    onFilterSelect: false
};

export const filterOffsetFromTopOfPage = () => {
    const brandBanner = document.querySelector('.brand-banner') as HTMLElement;
    const isSearchPage = window.location.href.indexOf("instantsearch") > -1;
    if (!isSearchPage)
        if (brandBanner) return isMobile() ? 0 : (175 + brandBanner.clientHeight);
        else return isMobile() ? 0 : 300;
}

export const setupFilters = (opts: object, context = document) => {
    const options = Object.assign(DEFAULTS, opts);
    const filtersContainer = context.querySelector(options.filtersContainer) as HTMLElement;
    const filterDraw = context.querySelector(options.filterDraw) as HTMLElement;

    if (filtersContainer) {
        const filterHeadings = filtersContainer.querySelectorAll(options.filterHeadings) as NodeListOf<HTMLElement>;
        const filterDrawHeadings = filterDraw.querySelectorAll(options.filterHeadings) as NodeListOf<HTMLElement>;
        const filterBody = filtersContainer.querySelectorAll(options.filterBody) as NodeListOf<HTMLElement>;
        const filterGroups = filterDraw.querySelectorAll(options.navLink) as NodeListOf<HTMLElement>;

        addFilterHeadingsEventListeners(filterHeadings, context);
        addFilterDrawHeadingsEventListeners(filterDrawHeadings, context);
        addFilterNavigationEventListeners(filterBody, options);
        addFilterGroupEventListeners(filterGroups);
        addOffCanvasPanelListeners();
        verticalSortBy();
        visibleFilterListeners();
    }
};

export function addFilterDrawEventHandlers() {
    const btn = document.querySelectorAll('.js-show-more-filters') as NodeListOf<HTMLElement>;
    const filterDraw = document.querySelector('.filters-draw') as HTMLElement;
    const filterOverlay = document.querySelector('.filter-overlay') as HTMLElement;
    const close = document.querySelectorAll('.js-hide-more-filters') as NodeListOf<HTMLElement>;

    //clear filters
    const clear = document.querySelector('.filter-group__close-all a');
    if (typeof clear !== 'undefined' && clear !== null) {
        clear.addEventListener('click', (e) => {
            e.preventDefault();
            closeFilterDraw();
            clearOpenFilter();
            location.href = clear.getAttribute('href');
        });
    }

    //Open filter draw
    if (typeof btn !== 'undefined' && btn !== null) {
        btn.forEach((elm) => {
            elm.addEventListener('click', () => {
                filterDraw.classList.add('active');
                filterOverlay.classList.add('active');
                toggleBodyOverflow(false);
            });
        });
    }

    //Close filter draw
    if (typeof close !== 'undefined' && close !== null) {
        close.forEach((elm) => {
            elm.addEventListener('click', () => {
                filterDraw.classList.remove('active');
                filterOverlay.classList.remove('active');
                resetFilterToggleStates();
                toggleBodyOverflow(true);
                clearSavedScrollPosition();
                clearOpenFilter();
            });
        });
    }
}

const openFilterDraw = (attribute: string) => {
    const filterDraw = document.querySelector('.filters-draw') as HTMLElement;
    const filterOverlay = document.querySelector('.filter-overlay') as HTMLElement;
    const selectedFilterGroup = filterDraw.querySelector(`[data-name="${attribute}"]`);

    filterDraw.classList.add('active');
    filterOverlay.classList.add('active');

    if (selectedFilterGroup !== null && typeof selectedFilterGroup !== 'undefined') {
        selectedFilterGroup.classList.add('active');
    }

    toggleBodyOverflow(false);

}

const resetFilterToggleStates = () => {
    const filterGroups = document.querySelectorAll('.horizontal-filters .filter-group') as NodeListOf<HTMLElement>;

    filterGroups.forEach((item) => {
        item.classList.remove('active');
    });
}

const closeFilterDraw = () => {
    const filterDraw = document.querySelector('.filters-draw') as HTMLElement;
    const filterOverlay = document.querySelector('.filter-overlay') as HTMLElement;

    filterDraw.classList.remove('active');
    filterOverlay.classList.remove('active');

    toggleBodyOverflow(true);
}


const closeAllFilterDrawGroups = () => {
    const filterDraw = document.querySelector('.filters-draw') as HTMLElement;
    const allFilterGroups = filterDraw.querySelectorAll('.filter-group') as NodeListOf<HTMLElement>;

    if (allFilterGroups.length > 0) {
        allFilterGroups.forEach((filterGroup) => {
            filterGroup.classList.remove('active');
        });
    }
}

export const toggleBodyOverflow = (isVisible: boolean) => {
    const body = document.querySelector('body') as HTMLElement;

    if (isVisible) body.removeAttribute('style');
    else body.style.overflowY = 'hidden';
};

const addFilterHeadingsEventListeners = (arrayOfFilterHeadings, context = document) => {
    for (let filterHeading of arrayOfFilterHeadings) {
        filterHeading.removeEventListener('click', filterHeadingEventListener);
        filterHeading.addEventListener('click', filterHeadingEventListener);
    }

    context.addEventListener('click', function (e) {     
        if (!(e.target as HTMLElement).closest('.filter-group') && !(e.target as HTMLElement).closest('.filter-group__visible-body')) {
            const filterHeadings = context.querySelectorAll('.filter-group__heading');
            const filterGroups = context.querySelectorAll('.filter-group');
            const filterBodies = context.querySelectorAll('.filter-group__body');
            const allDropdowns = document.querySelectorAll(`.filter-group__visible-body`) as NodeListOf<HTMLElement>;
            filterHeadings.forEach((el) => el.classList.remove('selected'));
            filterGroups.forEach((el) => {
                el.classList.remove('selected');
                el.classList.remove('active');
            });
            filterBodies.forEach((el) => el.classList.remove('is-visible'));
            allDropdowns.forEach((el) => el.classList.remove('active'));
        }
    });
};

const addFilterDrawHeadingsEventListeners = (arrayOfFilterHeadings, context = document) => {
    for (let filterHeading of arrayOfFilterHeadings) {
        filterHeading.removeEventListener('click', filterDrawHeadingEventListener);
        filterHeading.addEventListener('click', filterDrawHeadingEventListener);
    }
};

function filterDrawHeadingEventListener(e) {
    e.preventDefault();
    let filterHeading = e.target.closest('.filter-group__heading');
    let filterGroup = filterHeading.parentElement;
    filterGroup.classList.toggle('active');
}

function filterHeadingEventListener(e) {
    e.preventDefault();

    const filterHeading = e.target.closest('.filter-group__heading');
    const filterGroup = filterHeading.parentElement;
    const selectedFilterGroupName = filterGroup.dataset.name as string;
    const selectedFilterGroup = document.querySelector(`.filters-draw [data-name="${selectedFilterGroupName}"]`) as HTMLElement;
    const filterDrawBody = document.querySelector('.filters-draw__body') as HTMLElement;
    const allPageFilters = document.querySelectorAll(`.filter-group-wrapper .filter-group`) as NodeListOf<HTMLElement>;
    const allDropdowns = document.querySelectorAll(`.filter-group__visible-body`) as NodeListOf<HTMLElement>;
    const dropdown = document.querySelector(`.filter-group__visible-body[data-filtername="${selectedFilterGroupName}"]`) as HTMLElement;

    allDropdowns.forEach(elm => { elm.classList.remove('active'); });
    filterGroup.classList.toggle('active');

    if (selectedFilterGroupName.toLowerCase() == "price" || selectedFilterGroupName.toLowerCase() == "all filters") {
        closeAllFilterDrawGroups();
        openFilterDraw(selectedFilterGroupName);        

        if (selectedFilterGroup !== null && typeof selectedFilterGroup !== 'undefined') {
            clearOpenFilter();
            const selectedFilterOffsets = getOffset(selectedFilterGroup);
            let scrollOptions: ScrollToOptions = {
                top: selectedFilterOffsets.top - 55
            };
            scrollToOnContainer(scrollOptions, filterDrawBody, () => window.setTimeout(() => window.scroll(scrollOptions), 1000));
        }
    } else {
        if (filterGroup.classList.contains('active')) {
            allPageFilters.forEach(elm => { elm.classList.remove('active'); });
            filterGroup.classList.add('active');      
            dropdown.style.left = filterGroup.offsetLeft + 'px';
            dropdown.classList.add('active');
        } else filterGroup.classList.remove('active');      
    }       
}

const addFilterNavigationEventListeners = (filterBody: NodeListOf<HTMLElement>, options) => {
    for (let element of filterBody) {        
        element.addEventListener('click', (e) => {
            let target = e.target as HTMLElement;
            let link = target.closest('[href]:not(.no-ajax)');
            if (link) {
                link.classList.toggle('is-selected');

                if (target.closest(options.filterClearGroupButtons)) {
                    target
                        .closest(options.filterBody)
                        .querySelectorAll('.is-selected')
                        .forEach((el) => el.classList.remove('is-selected'));
                }

                if (target.closest(options.filterBody).querySelectorAll('.is-selected').length > 0) {
                    target.closest(options.filterGroup).classList.add('is-selected');
                } else {
                    target.closest(options.filterGroup).classList.remove('is-selected');
                }

                if (options.onFilterSelect) {
                    options.onFilterSelect(link.getAttribute('href'));
                }

                scrollWindowToTop();                

                dispatchEventWrapper(link, 'rc-filter-clicked', {
                    area: 'listing page',
                    event: 'filter clicked',
                    value: link.getAttribute('data-href') ? link.getAttribute('data-href') : link.getAttribute('href')
                });
            }
        });
    }
};

export const alignElementToBottom = (elementString: string, context = document) => {
    const windowHeight = window.innerHeight;
    const elements: NodeListOf<HTMLElement> = context.querySelectorAll(elementString);
    elements.forEach((element) => {
        const elementHeight = element.offsetHeight;
        if (elementHeight > 0) {
            let elementPositionTop = windowHeight - elementHeight;
            element.style.top = `${elementPositionTop}px`;
        }
    });
};

function scrollWindowToTop() {
    let scrollOptions: ScrollToOptions = {
        top: filterOffsetFromTopOfPage() - 10
    };
    scrollTo(scrollOptions, () => window.setTimeout(() => window.scroll(scrollOptions), 5));
}

const verticalSortBy = () => {
    const sortBytoggle = document.querySelector('.vertical-filters__sort-by .filter-group__sortby');
    const sortByHeading = document.querySelector('.vertical-filters__sort-by .filter-group__heading');
    const sortByBody = document.querySelector('.vertical-filters__sort-by .filter-group__body');
    if (sortBytoggle) {
        sortBytoggle.addEventListener('click', (e) => {
            sortBytoggle.classList.toggle('selected');
            sortByHeading.classList.toggle('selected');
            sortByBody.classList.toggle('is-visible');
            sortByBody.classList.toggle('is-active');
        });
    }
};

const addFilterGroupEventListeners = (arrayOfFilterGroups) => {
    for (let filterGroup of arrayOfFilterGroups) {
        filterGroup.addEventListener('click', (e) => {
            const filterType = filterGroup.closest('.filter-group').dataset.name;
            clearOpenFilter();
            saveOpenFilter(filterType);
            gaTracking("filter_click", false, {
                filter_category: filterGroup.getAttribute('data-title').replace('Filter by ', ''),
                filter_name: filterType,
                filter_applied: filterGroup.classList.contains('is-selected') ? false : true
            });
        });
    }
}; 

const visibleFilterListeners = () => {
    const links = document.querySelectorAll('.filter-group__visible-body a') as NodeListOf<HTMLLinkElement>;
    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const title = link.dataset.title;
            const parent = link.dataset.parent;
            const targetLink = document.querySelector(`.filters-draw .filter-group[data-name="${parent}"] .nav-link[data-title="${title}"]`) as HTMLElement;
            targetLink.click();
            clearOpenFilter();
            saveOpenFilter(parent, false);
        });
    })
};